export const ko = {
    translation: {
        b: {
            cancel: '취소',
            confirm: '확인',
            send: '보내기',
            done: '완료',
            close: '닫기',
            clear: '지우기',
            copy_link: '링크 복사',
            export: '내보내기',
            delete: '삭제',
            delete_confirm: '삭제 확인',
            duplicate: '복제',
            share: '공유',
            sign_in: '로그인',
            sign_up: '회원가입',
            email_address: '이메일 주소',
            yes: '예',
            no: '아니오'
        },
        m_languages: {
            title: '언어',
            subtitle: '언어를 선택하세요'
        },
        m_feedback: {
            feature: {
                name: '기능 요청',
                desc: '필요한 기능이 없나요? 알려주세요. 여러분의 아이디어는 소중합니다.'
            },
            feedback: {
                name: '피드백',
                desc: '여러분의 피드백은 매우 중요합니다. 짧은 메모라도 남겨주세요.'
            }
        },
        m_feedback_t: {
            feature: {
                name: '제안해 주셔서 감사합니다!',
                desc: '제안을 공유해 주셔서 감사합니다. 더 나은 제품을 만드는 데 도움이 됩니다.'
            },
            feedback: {
                name: '피드백 감사합니다!',
                desc: '소중한 의견을 공유해 주셔서 감사합니다.'
            }
        },
        m_diagram_details: {
            name_place: '프로젝트 이름 입력',
            desc_place: '프로젝트 설명 입력'
        },
        m_quick_share: {
            title: '빠른 공유',
            subtitle: '(쿼리 기반 링크 공유)'
        },
        m_export_img: {
            title: '이미지 내보내기'
        },
        m_export_code: {
            title: '코드 {{db_engine}} 내보내기',
            download_file: '파일 다운로드',
            copy_code: '코드 복사'
        },
        m_sign_in_remind: {
            // title: 'DB Design을 사용해 주셔서 감사합니다',
            title: '더 많은 기능을 사용하려면 로그인하세요',
            subtitle: '로그인 또는 회원가입하여 테이블 한도를 늘리고, 다이어그램을 저장하고, 더 많은 기능을 이용하세요'
        },
        m_sign_in_restrict: {
            title: '더 많은 기능을 사용하려면 로그인하세요',
            subtitle: '로그인 또는 회원가입하여 테이블 한도를 늘리고, 다이어그램을 저장하고, 더 많은 기능을 이용하세요'
        },
        m_new_diagram: {
            title: '새 다이어그램',
            subtitle: '데이터베이스 엔진 선택',
            open_diagram: '다이어그램 열기'
        },
        m_keyboard_shortcuts: {
            title: '키보드 단축키',
            ctrl_left: {
                title1: '컨트롤', // translationNote: UI에 따라 ‘제어’도 가능.
                title2: '(왼쪽)',
                items: {
                    mouse_sel: '마우스 선택 / 핸드 모드',
                    table: '테이블',
                    line: '선',
                    area: '영역',
                    note: '노트',
                    comment: '주석',
                    pen: '펜',
                    undo: '실행 취소',
                    redo: '다시 실행'
                }
            },
            ctrl_top_left: {
                title1: '컨트롤', // translationNote: ‘제어’도 가능.
                title2: '(왼쪽 상단)',
                items: {
                    export_img: '이미지 내보내기',
                    search: '검색',
                    editor_panel: '에디터 패널'
                }
            },
            ctrl_bottom_right: {
                title1: '컨트롤',
                title2: '(오른쪽 하단)',
                items: {
                    minimap: '미니맵',
                    zoom_in: '확대',
                    zoom_out: '축소',
                    zoom_100: '줌 100%'
                }
            },
            ctx_tab: {
                title1: '컨텍스트 메뉴',
                title2: '(테이블)',
                items: {
                    dupl_tab: '테이블 복제',
                    del_tab: '테이블 삭제'
                }
            },
            ctx_del_tab: {
                title1: '컨텍스트 메뉴',
                title2: '(테이블 삭제)',
                items: {
                    yes: '예',
                    no: '아니오'
                }
            },
            ctx_tab_col: {
                title1: '컨텍스트 메뉴',
                title2: '(테이블 열)',
                items: {
                    add_col_below: '아래에 열 추가',
                    focus_col_above: '포커스를 위 열로 이동',
                    focus_col_below: '포커스를 아래 열로 이동',
                    move_col_up: '열 위로 이동',
                    move_col_down: '열 아래로 이동',
                    dupl_col: '열 복제',
                    del_col: '열 삭제'
                }
            },
            ctx_line: {
                title1: '컨텍스트 메뉴',
                title2: '(선)',
                items: {
                    del_line: '선 삭제'
                }
            },
            ctx_area: {
                title1: '컨텍스트 메뉴',
                title2: '(영역)',
                items: {
                    dupl_area: '영역 복제',
                    del_area: '영역 삭제'
                }
            },
            ctx_multi: {
                title1: '컨텍스트 메뉴',
                title2: '(다중 선택)',
                items: {
                    select_all: '모든 요소 선택',
                    create_area_for_select_els: '선택한 요소용 영역 생성',
                    dupl_select_els: '선택한 요소 복제',
                    del_select_els: '선택한 요소 삭제'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: '마우스 선택',
                table: '테이블',
                line: '선',
                area: '영역',
                note: '노트(곧 제공)',
                comment: '주석(곧 제공)',
                pen: '펜',
                undo: '실행 취소',
                redo: '다시 실행'
            },
            ctrl_top_left: {
                logo: '참고: 여기는 샌드박스(테스트용)입니다',
                name: '다이어그램 정보',
                editor: '에디터(곧 제공)',
                search: '검색(곧 제공)',
                export: '내보내기 옵션',
                view_mode: '보기 모드',
                zoom_to_fit: '화면에 맞추기'
            },
            ctrl_top_right: {
                feature_req: '기능 요청',
                sign_in: '로그인',
                quick_share: '빠른 공유'
            },
            ctrl_bottom_right: {
                full_screen: '전체 화면',
                minimap: '미니맵',
                zoom_out: '축소',
                zoom_100: '줌 100%',
                zoom_in: '확대',
                info: '정보 및 리소스'
            },
            ctx: {
                base: {
                    colors: {
                        default: '기본',
                        blue: '파란색',
                        green: '초록색',
                        red: '빨간색',
                        purple: '보라색',
                        violet: '바이올렛'
                    },
                    borders: {
                        none: '없음',
                        solid: '실선',
                        dashed: '파선',
                        dotted: '점선'
                    },
                    color: '색상',
                    border: '테두리',
                    description: '설명',
                    description_table_place: '테이블 설명',
                    description_column_place: '열 설명',
                    description_line_place: '선 설명',
                    description_note_place: '노트 설명',
                    description_area_place: '영역 설명',
                    description_pen_place: '펜 설명',
                    hide_menu: '메뉴 숨기기',
                    show_menu: '메뉴 표시'
                },
                tab_col: {
                    add_col_below: '아래에 열 추가',
                    add_col_above: '위에 열 추가',
                    key: 'Key 설정',
                    keys: {
                        none: '없음',
                        pk: 'PK (기본 키)',
                        fk: 'FK (외래 키)'
                    },
                    index: 'Index',
                    indexes: {
                        none: '없음',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: '열 아래로 이동',
                    move_col_up: '열 위로 이동',
                    more_functions: '추가 기능'
                },
                line: {
                    change_connects: '커넥터 변경',
                    connects: {
                        empty: '없음',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update',
                    on_delete: 'On Delete'
                },
                area: {
                    filter: '요소 필터링'
                },
                multi: {
                    filter: '선택 필터링',
                    create_area: '영역 만들기'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: '전체',
            keys_only: '키만',
            names_only: '이름만'
        },
        dropdown_ctrl_export: {
            export_img: '이미지 내보내기',
            export_code: 'SQL 코드 내보내기'
        },
        dropdown_ctrl_settings: {
            sign_in: '로그인',
            new_project: '새 프로젝트',
            keyboard_shortcuts: '키보드 단축키',
            languages: '언어'
        },
        dropdown_ctrl_info_resources: {
            feedback: '피드백',
            keyboard_shortcuts: '키보드 단축키',
            languages: '언어',
            homepage: '홈페이지'
        },
        n: {
            default: '로딩 중…',
            file_ready_to_download: '파일을 다운로드할 수 있습니다',
            code_copied: '코드가 복사되었습니다',
            link_copied: '링크가 복사되었습니다',
            please_enter_message: '메시지를 입력해 주세요',
            invalid_email: '이메일 주소가 올바르지 않습니다',
            something_wrong_contact: '문제가 발생했습니다. 페이지를 새로고침하거나 문의해 주세요.',
            something_wrong: '문제가 발생했습니다. 페이지를 새로고침해 주세요.',
            sending: '전송 중…',
            request_sent: '요청이 전송되었습니다. 감사합니다!'
        }
    }
};

export const koMeta = {
    lang_origin: '한국어',
    lang_eng: 'Korean',
    lang_code: 'ko',
};
